export default __webpack_public_path__ + "static/media/logo.600414d2.jpg";